export const APP_LOGO_URL = "/media/openktv_logo.png";
export const APP_TEXT_LOGO_URL = "/media/branding_text.png";
